import React from 'react';
import { colors } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import { THEME as theme } from 'GlobalStyles';

import FPIcon from '../FPIcon';

import { styles, useCustomFPActionButton, useStyles } from './styles';

/** @typedef {import('types/app').FPActionButtonProps} FPActionButtonProps */

const { success } = theme.palette;

/**
 * @param {FPActionButtonProps} props
 */
const FPActionButton = ({
  children,
  icon,
  iconMode,
  iconPosition,
  iconProps,
  onClick,
  size,
  style,
  text,
  variant,
  withGradient = false,
  ...rest
}) => {
  const iconPositions = {
    right: 'right',
    left: 'left',
    none: 'none'
  };

  const classes = useStyles();

  const FPClasses = useCustomFPActionButton();

  const iconDefinitions = {
    family: {
      custom: 'custom',
      streamline: 'streamline'
    },
    iconSize: {
      small: 16,
      medium: 20,
      large: 24
    }
  };

  const colorValue = type =>
    iconMode === iconDefinitions.family[type]
      ? `${variant === 'outlined' ? success.main : colors.common.white}`
      : null;

  const sizeValue = iconDefinitions.iconSize[size];

  const iconToRender = position =>
    iconPosition === position ? (
      <>
        {children || (
          <FPIcon
            component={icon}
            fill={colorValue(iconDefinitions.family.custom)}
            color={colorValue(iconDefinitions.family.streamline)}
            style={!children && !icon ? styles.emptyDiv : null}
            size={sizeValue}
            {...iconProps}
          />
        )}
      </>
    ) : (
      variant !== 'text' && <FPIcon size={sizeValue} style={styles.emptyDiv} />
    );

  const getIcon = position => (icon || children ? iconToRender(position) : null);

  const handleClick = e => onClick && onClick(e);
  return (
    <Button
      variant={variant}
      classes={{
        ...classes,
        containedPrimary: withGradient ? FPClasses.containedPrimary : classes.containedPrimary,
        outlinedPrimary: withGradient ? FPClasses.outlinedPrimary : classes.outlinedPrimary,
        disabled: FPClasses.outlined,
        label: variant === 'text' ? FPClasses.label : classes.label
      }}
      onClick={handleClick}
      style={style}
      endIcon={getIcon(iconPositions.right)}
      startIcon={getIcon(iconPositions.left)}
      size={size}
      {...rest}
    >
      {text.trim()}
    </Button>
  );
};

FPActionButton.defaultProps = {
  children: undefined,
  color: 'primary',
  iconMode: 'custom',
  iconPosition: 'left',
  iconProps: null,
  onClick: () => {},
  size: 'large',
  style: {},
  text: '',
  type: 'button',
  variant: 'contained'
};

export default FPActionButton;
